




































































import { Prop, Component, Vue } from "vue-property-decorator";
import Action from "@/models/action";
import Chart from "@/models/chart";
import ChartRow from "@/models/chart-row";
import ChartBar from "@/models/chart-bar";
import VChart from "@/components/chart/VChart.vue";
import VChartRow from "@/components/chart/VChartRow.vue";
import VChartBody from "@/components/chart/VChartBody.vue";
import VChartHeader from "@/components/chart/VChartHeaderSimple.vue";
import VToolbar from "@/components/VToolbar.vue";
import VProxyWindow from "@/components/VProxyWindow.vue";
import ProjectTemplate from "../models/project-template";
import { GridMask } from "../viewmodels/grid-mask";
import VGridMask from "../components/VGridMask.vue";
import VChartOperator from "../components/chart/VChartOperator.vue";

@Component({
  components: {
    VChart,
    VChartRow,
    VChartBody,
    VChartHeader,
    VChartOperator,
    VGridMask,
    VToolbar,
    VProxyWindow
  },
  props: {
    active: {
      type: Boolean,
      default: false
    }
  }
})
export default class PlanEdit extends Vue {
  @Prop({ required: true }) chart!: Chart;
  @Prop({ default: () => new ProjectTemplate() }) template!: ProjectTemplate;
  @Prop({ default: () => [] }) cols!: { text: string; color: string }[];
  @Prop({ default: () => [] }) rows!: ChartRow[];
  @Prop({ default: () => [] }) actions!: Action[];

  get chartMask(): GridMask {
    return {
      cols: this.cols.map(c => ({ color: c.color }))
    };
  }

  get colTextList() {
    return this.cols.map(c => c.text);
  }

  clickRow(rowIndex: number, colIndex: number) {
    this.$emit("newTask", this.rows[rowIndex].id, colIndex);
  }

  select(bar: ChartBar) {
    this.$emit("editTask", bar.id);
  }

  change(newBar: ChartBar) {
    this.$emit("change", newBar);
  }

  submit() {
    this.$emit("submit");
  }

  cancel() {
    this.$emit("cancel");
  }

  saveTitle() {
    this.$emit("saveTemplate", this.template);
  }

  sort(rows: ChartRow[]) {
    this.$emit("sort", rows);
  }
}
